import React, { useState } from "react";
import "./Need_Help.css";
import Common_Heading from "../../common-components/common-heading/Common_Heading";
import Common_Btn from "../../common-components/common-btn/Common_Btn";
import Message_Send_Modal from "../need-help/Message_Send_Modal/Message_Send_Modal";
import { useNavigate } from "react-router-dom";

function Need_Help() {
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const htmlFormat = `
      <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #eee; border-radius: 8px; max-width: 600px; margin: auto;">
        <h2 style="color: #4CAF50; border-bottom: 2px solid #4CAF50; padding-bottom: 8px;">
          📩 New Support Request
        </h2>
        <table style="width: 100%; border-collapse: collapse; margin-top: 15px;">
          <tr>
            <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Name</td>
            <td style="padding: 10px; border: 1px solid #ddd;">${formData.name}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Email</td>
            <td style="padding: 10px; border: 1px solid #ddd;">${formData.email}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Phone</td>
            <td style="padding: 10px; border: 1px solid #ddd;">${formData.phone}</td>
          </tr>
          <tr>
            <td style="padding: 10px; border: 1px solid #ddd; font-weight: bold;">Message</td>
            <td style="padding: 10px; border: 1px solid #ddd;">${formData.message}</td>
          </tr>
        </table>
      </div>
    `;

    const payload = {
      email: "vaishnavis.cse21d@sbjit.edu.in",
      subject: `Support Request: ${formData.name}`,
      html: htmlFormat,
      key: "Profcyma",
    };

    try {
      const response = await fetch(
        "https://emailservices.hostelbliss.com:3301/common-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      if (response.ok) {
        setShowModal(true); // ✅ SHOW LOTTIE MODAL
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });

        setTimeout(() => {
          navigate("/");
          setShowModal(false);
        }, 3000);
      } else {
        alert("Failed to send message. Try again.");
      }
    } catch (error) {
      console.error("Email error:", error);
      alert("Network error. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <section className="need_help_section">
        <div className="container">
          <div className="img_holder">
            <div className="btn-holder">
              <div className="p">24 / 7 SUPPORT AVAILABLE</div>
            </div>

            <img
              src="/assets/images/contact-us/contact-banner.png"
              alt="need_help_img"
              className="contact_banner"
            />

            <div className="content_holder">
              <Common_Heading head1="NEED HELP" head2="WITH YOUR INNINGS" />
            </div>

            <p className="description">
              Our world-class support team is standing by to assist you with
              your betting <br /> experience, withdrawals and game rules.
            </p>
          </div>
        </div>

        <div className="contact_card_section">
          <div className="container">
            <div className="contact_card">
              <h3 className="contact_title">SEND US A MESSAGE</h3>

              <form className="contact_form" onSubmit={handleSubmit}>
                <input
                  type="text"
                  placeholder="Enter your name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />

                <div className="two_col">
                  <input
                    type="email"
                    placeholder="Enter your email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  <input
                    type="tel"
                    placeholder="Enter your Number"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>

                <textarea
                  placeholder="Type here..."
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                />

                <div className="submit_btn">
                  <Common_Btn
                    btnText={isSubmitting ? "Sending..." : "Submit"}
                    disabled={isSubmitting}
                    type="submit"
                  />
                </div>
              </form>

              <div className="icon_holder">
                <div className="social_icons">
                  <a
                    href=" https://www.facebook.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/images/contact-us/fb.png"
                      alt="fb"
                      className="icons"
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/images/contact-us/insta.png"
                      alt="ig"
                      className="icons"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="/assets/images/contact-us/youtube.png"
                      alt="yt"
                      className="icons"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Message_Send_Modal
          showAccountModal={showModal}
          handleAccountModalClose={() => setShowModal(false)}
        />
      </section>
    </>
  );
}

export default Need_Help;
